export type HourReportTableHeadCell = {
  disablePadding: boolean
  id: string
  label: string
}

export const makeHourReportTableHeadCells = (
  supportsSubmission: boolean,
  statusLabel: string,
  labels: { projectTask: string; hours: string; description: string; actions: string } = {
    projectTask: "Project/Task",
    hours: "Hours",
    description: "Description",
    actions: "",
  }
): HourReportTableHeadCell[] => [
  { id: "projectOrTask", disablePadding: false, label: labels.projectTask },
  { id: "hours", disablePadding: false, label: labels.hours },
  ...(supportsSubmission ? [{ id: "status", disablePadding: false, label: statusLabel }] : []),
  { id: "description", disablePadding: false, label: labels.description },
  { id: "actions", disablePadding: false, label: labels.actions },
]

export const getHourReportStatusLabel = ({
  supportsChecking,
  supportsApproval,
  labels,
}: {
  supportsChecking?: boolean
  supportsApproval?: boolean
  labels?: { readyForCheck: string; readyForApproval: string }
}) => {
  const statusLabels = labels ?? { readyForCheck: "Ready for check", readyForApproval: "Ready for approval" }
  if (supportsChecking) return statusLabels.readyForCheck
  if (supportsApproval) return statusLabels.readyForApproval
  return statusLabels.readyForCheck
}
